import { Fragment } from 'react';
import { PendingSignerRecipients } from './PendingSignerRecipients';
import { PendingViewerRecipients } from './PendingViewerRecipients';
export function PendingRecipients() {
    return (<Fragment>
      <PendingSignerRecipients />
      <PendingViewerRecipients />
    </Fragment>);
}
